import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="A local news site dedicated to daily updates on events, politics, and community stories from Fairfax City." 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">Fairfax Daily · Your Source for Local News</p>
        <h1>Stay Informed with Fairfax Daily</h1>
        <p className="lede">
          Discover the latest updates on events, politics, and community stories that matter to you in Fairfax City. 
          Join us as we bring you the news that shapes our community every day.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/subscribe" target="_self" className="secondary">
            Subscribe for Updates
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Daily Updates</h2>
          <p>
            Get timely news coverage on local events and important political developments that affect our community.
          </p>
        </article>
        <article>
          <h2>Community Stories</h2>
          <p>
            Explore inspiring stories from your neighbors and learn about the people and organizations making a difference in Fairfax City.
          </p>
        </article>
        <article>
          <h2>Engage with Us</h2>
          <p>
            Join the conversation! Share your thoughts on our articles and connect with fellow residents through our community forums.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;